/* Candor Luxe theme: menu, bag drawer (Shopify AJAX cart), filters, product page. */
(function () {
  const CL = window.CL || {};
  const R = Object.assign({ cart: "/cart", add: "/cart/add", change: "/cart/change", update: "/cart/update" }, CL.routes);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function money(cents) {
    const fmt = CL.moneyFormat || "₹{{amount_no_decimals}}";
    const n = cents / 100;
    const key = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || "amount";
    let v;
    if (key === "amount_no_decimals") v = Math.round(n).toLocaleString("en-IN");
    else if (key.indexOf("comma") > -1) v = key.indexOf("no_decimals") > -1 ? Math.round(n).toLocaleString("de-DE") : n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else v = Number.isInteger(n) ? n.toLocaleString("en-IN") : n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, "");
  }
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  // ---------- Mobile menu ----------
  const menuBtn = $(".menu-btn");
  if (menuBtn) menuBtn.addEventListener("click", () => {
    const open = menuBtn.getAttribute("aria-expanded") !== "true";
    menuBtn.setAttribute("aria-expanded", open);
    document.body.classList.toggle("nav-open", open);
  });

  // ---------- Toast ----------
  let toastTimer;
  function toast(msg) {
    const t = $(".toast"); if (!t) return;
    t.textContent = msg; t.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("show"), 2400);
  }

  // ---------- Bag drawer ----------
  const drawer = $(".drawer"), scrim = $(".scrim");
  let lastFocus = null, cart = null;

  async function getCart() {
    const r = await fetch(R.cart + ".js", { headers: { Accept: "application/json" } });
    cart = await r.json();
    return cart;
  }
  async function post(url, body) {
    const r = await fetch(url + ".js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || "Something went wrong. Try again.");
    return data;
  }

  function renderBag() {
    if (!drawer || !cart) return;
    $$(".bag-count").forEach((el) => (el.textContent = cart.item_count));
    const body = $(".drawer__body", drawer), foot = $(".drawer__foot", drawer);
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><p>Your bag is empty.</p><a class="btn btn--light" href="/collections/all">Shop candles</a></div>`;
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map((it) => `
      <div class="line">
        ${it.image ? `<img src="${esc(it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160")}" alt="" width="72" height="90">` : "<span></span>"}
        <div class="line__info">
          <a href="${esc(it.url)}" class="line__name">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? (it.product_type ? `<span class="muted small">${esc(it.product_type)}</span>` : "") : `<span class="muted small">${esc(it.variant_title)}</span>`}
          <div class="qty" data-key="${esc(it.key)}">
            <button data-d="-1" aria-label="Decrease quantity of ${esc(it.product_title)}">−</button>
            <span aria-live="polite">${it.quantity}</span>
            <button data-d="1" aria-label="Increase quantity of ${esc(it.product_title)}">+</button>
          </div>
        </div>
        <div class="line__price">${money(it.final_line_price)}</div>
      </div>`).join("");
    foot.hidden = false;
    $(".subtotal__value", foot).textContent = money(cart.total_price);
    const threshold = (Number(CL.freeShip) || 0) * 100;
    $(".ship-msg", foot).textContent = !threshold ? "" : cart.total_price >= threshold
      ? "Your order ships free within India."
      : `Shipping is ₹30. Add ${money(threshold - cart.total_price)} more for free shipping within India.`;
    const wrap = $("#gift-wrap"), note = $("#gift-note");
    if (wrap) wrap.checked = (cart.attributes || {})["Gift wrap"] === "Yes";
    if (note && document.activeElement !== note) note.value = cart.note || "";
  }

  async function openBag() {
    if (!drawer) { location.href = R.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(() => document.body.classList.add("bag-open"));
    $(".drawer__close", drawer).focus();
    await getCart(); renderBag();
  }
  function closeBag() {
    document.body.classList.remove("bag-open");
    setTimeout(() => { drawer.hidden = true; scrim.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-bag]")) { e.preventDefault(); openBag(); }
    if (e.target.closest(".drawer__close") || e.target === scrim) closeBag();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && drawer && !drawer.hidden) closeBag(); });

  if (drawer) {
    drawer.addEventListener("click", async (e) => {
      const b = e.target.closest(".qty button");
      if (b) {
        const key = b.parentElement.dataset.key;
        const line = cart.items.find((i) => i.key === key);
        b.disabled = true;
        try { cart = await post(R.change, { id: key, quantity: Math.max(0, line.quantity + Number(b.dataset.d)) }); renderBag(); }
        catch (err) { toast(err.message); b.disabled = false; }
      }
      if (e.target.closest(".checkout")) {
        const btn = e.target.closest(".checkout");
        btn.disabled = true; btn.textContent = "Opening checkout…";
        try { await saveGift(); } catch (err) {}
        location.href = "/checkout";
      }
    });
    const wrap = $("#gift-wrap"), note = $("#gift-note");
    let noteTimer;
    async function saveGift() {
      return post(R.update, { note: note ? note.value : "", attributes: { "Gift wrap": wrap && wrap.checked ? "Yes" : "" } });
    }
    if (wrap) wrap.addEventListener("change", () => saveGift().catch((err) => toast(err.message)));
    if (note) note.addEventListener("input", () => { clearTimeout(noteTimer); noteTimer = setTimeout(() => saveGift().catch(() => {}), 600); });
  }

  // ---------- Add to bag (any product form) ----------
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest("form.js-add");
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = "Adding…";
    try {
      const r = await fetch(R.add + ".js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || "This candle couldn't be added. Try again.");
      await getCart(); renderBag();
      toast(`${data.product_title || "Candle"} added to your bag`);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.disabled = false; btn.textContent = label;
    }
  });

  // ---------- Quantity stepper on product page ----------
  $$("[data-qty]").forEach((q) => {
    const input = $("input", q);
    q.addEventListener("click", (e) => {
      const b = e.target.closest("button"); if (!b) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.d));
    });
  });

  // ---------- Product photo thumbnails ----------
  $$(".thumb").forEach((t) => t.addEventListener("click", () => {
    const main = $(".pdp__media img");
    if (main) { main.removeAttribute("srcset"); main.src = t.dataset.src; }
    $$(".thumb").forEach((x) => x.setAttribute("aria-pressed", x === t));
  }));
  if (location.hash === "#care" && $("#care")) $("#care").open = true;

  // ---------- Collection sorting ----------
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => {
    const u = new URL(location.href);
    u.searchParams.set("sort_by", sort.value);
    u.searchParams.delete("page");
    location.href = u.toString();
  });

  // ---------- Budget filter (gifting) ----------
  const budget = $("#budget");
  if (budget) {
    const cards = $$("#collection-grid .piece");
    const empty = $(".budget-empty");
    $$("button", budget).forEach((b) => b.addEventListener("click", () => {
      const lo = Number(b.dataset.min), hi = Number(b.dataset.max);
      let shown = 0;
      cards.forEach((c) => { const p = Number(c.dataset.price); const ok = p >= lo && p <= hi; c.hidden = !ok; if (ok) shown++; });
      if (empty) empty.hidden = shown > 0;
      $$("button", budget).forEach((x) => x.setAttribute("aria-pressed", x === b));
    }));
  }

  // ---------- Product row arrows ----------
  $$("[data-row]").forEach((wrap) => {
    const row = $(".row", wrap);
    $$("[data-dir]", wrap).forEach((b) => b.addEventListener("click", () =>
      row.scrollBy({ left: Number(b.dataset.dir) * row.clientWidth * 0.8, behavior: "smooth" })));
  });
})();
